import { DetailDescriptionDataSource } from './DetailDescriptionDataSource';
import { IAssetPriceResponse3 } from '../../api/models/AndromeTV.types';
import { DataSource } from '../cms/DataSource';
import { VodAsset } from './vod/VodAsset';
import { VodStreamRights } from './vod/VodStreamRights';
import { Lightning } from '@lightningjs/sdk';
import { DetailAction } from './actions/DetailAction';
import { TabbedRecordingRibbonDataSource } from '../cms/TabbedRecordingRibbonDataSource';
import { TabbedEpgEpisodesRibbonDataSource } from '../cms/TabbedEpgEpisodesRibbonDataSource';
import { RibbonDataSource } from '../cms/RibbonDataSource';
import { TabbedEpisodeRibbonDataSource } from '../cms/TabbedEpisodeRibbonDataSource';

export interface IDetailDescription {
  title?: string;
  synopsis?: string;
  ageRating?: IconDef;
  score?: IScoreData;
  metaInformation?: string;
  expire?: string;
  recordingError?: string;
  pricing?: string;
  subscription?: string;
  resolution?: IconDef;
  blackout?: string;
  secondaryMetaInfo?: string;
  credits?: Map<string, string>;
  parentalControlIcons?: IconDef[];
  bookmarkPercentage?: number;
  accessibilityIcons?: IconDef[];
  recordingIcons?: IconDef[];
  play?: IconDef;
}

export interface IconDef {
  src: string;
  color?: number;
}

export interface IScoreData {
  imdb: number;
  operator: number;
}

export interface IDetailModel {
  description: DetailDescriptionDataSource;
  images: { detailPoster: string | undefined };
  buttons: IActionButtonDefinition[];
  ribbonDatasources: RibbonDataSources;
}

export type RibbonDataSources = (
  | DataSource
  | RibbonDataSource
  | TabbedEpisodeRibbonDataSource
  | TabbedEpgEpisodesRibbonDataSource
  | TabbedRecordingRibbonDataSource
)[];

export interface IRentableQuality {
  text: string;
  quote: IAssetPriceResponse3;
}

/**
 * @note any other properties depending on button
 */
export interface IActionButtonDefinition {
  type: typeof Lightning.Component;
  actionHandler: DetailAction;
  label: string;
}

export interface NextEpisodeInfo {
  asset: VodAsset;
  streamRights: VodStreamRights;
}

/**
 * @type {{FEAR: string, VIOLENCE: string, DISCRIMINATION: string, COARSELANGUAGE: string, DRUGS: string, SEX: string}}
 */
export const ParentalRatings = {
  COARSELANGUAGE: 'COARSELANGUAGE',
  DISCRIMINATION: 'DISCRIMINATION',
  DRUGS: 'DRUGS',
  FEAR: 'FEAR',
  SEX: 'SEX',
  VIOLENCE: 'VIOLENCE',
};

export const CreditTypes = {
  ACTOR: 'ACTOR',
  DIRECTOR: 'DIRECTOR',
  ANCHOR: 'ANCHOR',
  ART_DIRECTOR: 'ART_DIRECTOR',
  PERFORMER: 'PERFORMER',
  REPORTER: 'REPORTER',
  PRODUCER: 'PRODUCER',
  SCENARIST: 'SCENARIST',
  VOICE_OVER_ARTIST: 'VOICE_OVER_ARTIST',
  COMMENTATOR: 'COMMENTATOR',
  CO_COMMENTATOR: 'CO_COMMENTATOR',
  LINE_REPORTERS: 'LINE_REPORTERS',
  WRITER: 'WRITER',
};

export const VodAssetStreamType = {
  TRAILER: 'TRAILER',
  FULL: 'FULL',
};

export const QuoteType = {
  TVOD: 'TVOD',
  BUNDLE: 'BUNDLE',
};
